import { useEffect, useState } from 'react';

const API = 'https://ticobaterias.com/api';
const PROVINCIAS = ['San José','Alajuela','Cartago','Heredia','Guanacaste','Puntarenas','Limón'];
const token = () => localStorage.getItem('token');
const vacio = {
  provincia: 'San José', nombre: '', telefono: '', whatsapp: '',
  email: '', direccion: '', descripcion: '', orden: 0
};

export default function Distribuidores() {
  const [lista, setLista] = useState<any[]>([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState<any>(null);
  const [editando, setEditando] = useState<any>(null);
  const [form, setForm] = useState<any>(vacio);
  const [cargando, setCargando] = useState(false);
  const [filtro, setFiltro] = useState('Todas');
  const [toast, setToast] = useState('');
  const [confirmId, setConfirmId] = useState<number|null>(null);
  const [subiendoFoto, setSubiendoFoto] = useState(false);
  const [subiendoVideo, setSubiendoVideo] = useState(false);

  const mostrarToast = (msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(''), 3000);
  };

  const cargar = async () => {
    const r = await fetch(`${API}/distribuidores/`);
    setLista(await r.json());
  };

  useEffect(() => { cargar(); }, []);

  const abrirNuevo = () => { setEditando(null); setForm(vacio); setModal(true); };
  const abrirEditar = (d: any) => {
    setEditando(d);
    setForm({ provincia: d.provincia, nombre: d.nombre, telefono: d.telefono||'',
      whatsapp: d.whatsapp||'', email: d.email||'', direccion: d.direccion||'',
      descripcion: d.descripcion||'', orden: d.orden||0 });
    setModal(true);
  };

  const guardar = async () => {
    setCargando(true);
    try {
      const url = editando ? `${API}/distribuidores/${editando.id}` : `${API}/distribuidores/`;
      const r = await fetch(url, {
        method: editando ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ ...form, orden: Number(form.orden) })
      });
      if (!r.ok) throw new Error();
      await cargar();
      setModal(false);
      mostrarToast(editando ? '✅ Distribuidor actualizado' : '✅ Distribuidor creado');
    } catch { mostrarToast('❌ Error al guardar'); }
    setCargando(false);
  };

  const eliminar = async (id: number) => {
    await fetch(`${API}/distribuidores/${id}`, {
      method: 'DELETE', headers: { Authorization: `Bearer ${token()}` }
    });
    setConfirmId(null);
    await cargar();
    mostrarToast('🗑️ Distribuidor eliminado');
  };

  const subirFoto = async (id: number, file: File) => {
    setSubiendoFoto(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch(`${API}/distribuidores/${id}/foto`, {
        method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd
      });
      if (!r.ok) throw new Error();
      await cargar();
      setModalMedia((prev: any) => ({ ...prev, foto_url: lista.find(d => d.id === id)?.foto_url }));
      mostrarToast('✅ Foto subida correctamente');
    } catch { mostrarToast('❌ Error al subir foto'); }
    setSubiendoFoto(false);
  };

  const subirVideo = async (id: number, file: File) => {
    setSubiendoVideo(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await fetch(`${API}/distribuidores/${id}/video`, {
        method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd
      });
      if (!r.ok) throw new Error();
      await cargar();
      mostrarToast('✅ Video subido correctamente');
    } catch { mostrarToast('❌ Error al subir video'); }
    setSubiendoVideo(false);
  };

  const listafiltrada = filtro === 'Todas' ? lista : lista.filter(d => d.provincia === filtro);

  return (
    <div>
      {/* Toast */}
      {toast && (
        <div className="fixed top-6 right-6 z-50 bg-white border border-gray-200 shadow-xl rounded-xl px-5 py-3 text-sm font-semibold text-gray-700">
          {toast}
        </div>
      )}

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-azul">Distribuidores</h1>
          <p className="text-gray-500 text-sm mt-1">Gestioná la red de distribuidores por provincia</p>
        </div>
        <button onClick={abrirNuevo}
          className="bg-rojo hover:bg-rojo-dark text-white px-5 py-2.5 rounded-xl font-semibold text-sm transition-all">
          + Nuevo Distribuidor
        </button>
      </div>

      {/* Filtro */}
      <div className="flex gap-2 flex-wrap mb-6">
        {['Todas', ...PROVINCIAS].map(p => (
          <button key={p} onClick={() => setFiltro(p)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all border ${
              filtro === p ? 'bg-azul text-white border-azul' : 'bg-white text-gray-600 border-gray-200 hover:border-azul hover:text-azul'
            }`}>{p}</button>
        ))}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {PROVINCIAS.map(p => {
          const count = lista.filter(d => d.provincia === p).length;
          if (!count) return null;
          return (
            <div key={p} className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
              <div className="text-2xl font-bold text-azul">{count}</div>
              <div className="text-xs text-gray-500 mt-1">{p}</div>
            </div>
          );
        })}
      </div>

      {/* Tabla */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {listafiltrada.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <div className="text-4xl mb-3">🗺️</div>
            <div className="font-medium">No hay distribuidores {filtro !== 'Todas' ? `en ${filtro}` : ''}</div>
            <div className="text-sm mt-1">Agregá el primero con el botón de arriba</div>
          </div>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-100">
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Distribuidor</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Provincia</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Contacto</th>
                <th className="text-left px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Media</th>
                <th className="text-right px-6 py-4 text-xs font-semibold text-gray-500 uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {listafiltrada.map(d => (
                <tr key={d.id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="font-semibold text-gray-800">{d.nombre}</div>
                    {d.direccion && <div className="text-xs text-gray-400 mt-0.5 truncate max-w-xs">{d.direccion}</div>}
                  </td>
                  <td className="px-6 py-4">
                    <span className="bg-azul/10 text-azul text-xs font-semibold px-3 py-1 rounded-full">{d.provincia}</span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600">
                    {d.telefono && <div>📞 {d.telefono}</div>}
                    {d.whatsapp && <div>💬 {d.whatsapp}</div>}
                    {d.email && <div className="text-xs text-gray-400">{d.email}</div>}
                  </td>
                  <td className="px-6 py-4">
                    <button onClick={() => setModalMedia(d)}
                      className={`text-xs font-semibold px-3 py-1.5 rounded-lg transition-all ${
                        d.foto_url || d.video_url
                          ? 'bg-green-50 text-green-600 hover:bg-green-100'
                          : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                      }`}>
                      {d.foto_url || d.video_url ? '📎 Ver media' : '📎 Subir media'}
                    </button>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button onClick={() => abrirEditar(d)}
                      className="text-azul hover:text-azul-dark font-medium text-sm mr-4 transition-colors">Editar</button>
                    <button onClick={() => setConfirmId(d.id)}
                      className="text-rojo hover:text-rojo-dark font-medium text-sm transition-colors">Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal Media */}
      {modalMedia && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center">
              <h2 className="text-lg font-bold text-azul">Foto y Video — {modalMedia.nombre}</h2>
              <button onClick={() => { setModalMedia(null); cargar(); }} className="text-gray-400 hover:text-gray-600 text-xl">✕</button>
            </div>
            <div className="p-6 space-y-6">

              {/* Foto */}
              <div>
                <div className="text-sm font-semibold text-gray-700 mb-3">📸 Foto del distribuidor</div>
                {modalMedia.foto_url ? (
                  <div className="relative group">
                    <img src={`https://ticobaterias.com${modalMedia.foto_url}`}
                      className="w-full h-48 object-cover rounded-xl border border-gray-200" alt="foto" />
                    <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-all rounded-xl flex items-center justify-center">
                      <label className="cursor-pointer bg-white text-azul font-semibold text-sm px-4 py-2 rounded-lg">
                        Cambiar foto
                        <input type="file" accept="image/jpg,image/jpeg,image/png,image/webp" className="hidden"
                          onChange={e => e.target.files && subirFoto(modalMedia.id, e.target.files[0])} />
                      </label>
                    </div>
                  </div>
                ) : (
                  <label className="cursor-pointer block border-2 border-dashed border-gray-200 rounded-xl p-8 text-center hover:border-azul transition-all">
                    <div className="text-3xl mb-2">{subiendoFoto ? '⏳' : '🖼️'}</div>
                    <div className="text-sm font-medium text-gray-600">{subiendoFoto ? 'Subiendo...' : 'Clic para subir foto'}</div>
                    <div className="text-xs text-gray-400 mt-1">JPG, PNG, WEBP</div>
                    <input type="file" accept="image/jpg,image/jpeg,image/png,image/webp" className="hidden"
                      onChange={e => e.target.files && subirFoto(modalMedia.id, e.target.files[0])} />
                  </label>
                )}
              </div>

              {/* Video */}
              <div>
                <div className="text-sm font-semibold text-gray-700 mb-3">🎥 Video del distribuidor</div>
                {modalMedia.video_url ? (
                  <div>
                    <video src={`https://ticobaterias.com${modalMedia.video_url}`}
                      controls className="w-full rounded-xl border border-gray-200 max-h-48" />
                    <label className="cursor-pointer mt-3 block text-center text-sm text-azul hover:underline font-medium">
                      Cambiar video
                      <input type="file" accept="video/mp4,video/webm,video/mov" className="hidden"
                        onChange={e => e.target.files && subirVideo(modalMedia.id, e.target.files[0])} />
                    </label>
                  </div>
                ) : (
                  <label className="cursor-pointer block border-2 border-dashed border-gray-200 rounded-xl p-8 text-center hover:border-azul transition-all">
                    <div className="text-3xl mb-2">{subiendoVideo ? '⏳' : '🎬'}</div>
                    <div className="text-sm font-medium text-gray-600">{subiendoVideo ? 'Subiendo...' : 'Clic para subir video'}</div>
                    <div className="text-xs text-gray-400 mt-1">MP4, WEBM, MOV</div>
                    <input type="file" accept="video/mp4,video/webm,video/mov" className="hidden"
                      onChange={e => e.target.files && subirVideo(modalMedia.id, e.target.files[0])} />
                  </label>
                )}
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal Confirmar eliminar */}
      {confirmId !== null && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6">
            <div className="text-4xl text-center mb-3">🗑️</div>
            <h3 className="text-lg font-bold text-gray-800 text-center mb-2">¿Eliminar distribuidor?</h3>
            <p className="text-sm text-gray-500 text-center mb-6">Esta acción no se puede deshacer.</p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmId(null)}
                className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-all">
                Cancelar
              </button>
              <button onClick={() => eliminar(confirmId)}
                className="flex-1 px-4 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold transition-all">
                Sí, eliminar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Formulario */}
      {modal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-100">
              <h2 className="text-lg font-bold text-azul">{editando ? 'Editar Distribuidor' : 'Nuevo Distribuidor'}</h2>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Provincia *</label>
                <select value={form.provincia} onChange={e => setForm({...form, provincia: e.target.value})}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul">
                  {PROVINCIAS.map(p => <option key={p}>{p}</option>)}
                </select>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Nombre *</label>
                <input value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})}
                  placeholder="Nombre del distribuidor"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-700 block mb-1">Teléfono</label>
                  <input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})}
                    placeholder="2200-0000"
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-700 block mb-1">WhatsApp</label>
                  <input value={form.whatsapp} onChange={e => setForm({...form, whatsapp: e.target.value})}
                    placeholder="+506 8507-6464"
                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
                </div>
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Email</label>
                <input value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                  placeholder="distribuidor@email.com" type="email"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Dirección</label>
                <input value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})}
                  placeholder="Dirección del local"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Descripción</label>
                <textarea value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                  placeholder="Descripción opcional..." rows={3}
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul resize-none" />
              </div>
              <div>
                <label className="text-sm font-medium text-gray-700 block mb-1">Orden de aparición</label>
                <input value={form.orden} onChange={e => setForm({...form, orden: e.target.value})}
                  type="number" min="0" placeholder="0"
                  className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-azul" />
              </div>
            </div>
            <div className="p-6 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setModal(false)}
                className="px-5 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-all">
                Cancelar
              </button>
              <button onClick={guardar} disabled={cargando || !form.nombre}
                className="px-5 py-2.5 rounded-xl bg-rojo hover:bg-rojo-dark text-white text-sm font-semibold transition-all disabled:opacity-50">
                {cargando ? 'Guardando...' : editando ? 'Guardar Cambios' : 'Crear Distribuidor'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
